<template>
  <div class="pc-lecture-detail detail-page">
    <BreadCrumb :data="breadcrumb" :title="'课程详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <!-- 基本介绍 -->

    <div class="detail-form-information" v-show="!isEditting">
      <h2>基本信息</h2>
      <div class="information-hint">
        <span>
          创建于:
          {{ $dtime(lectureDetail.createTime).format("YYYY-MM-DD") }} &nbsp;
        </span>
        <span>
          最近更新:
          {{ $dtime(lectureDetail.updateTime).format("YYYY-MM-DD") }}</span
        >
      </div>
      <div class="form-content">
        <div class="form-content-img">
          <img
            v-if="lectureDetail.cover_image"
            :src="lectureDetail.cover_image"
            alt=""
          />
          <img v-else src="../../../../static/image/no-img.png" alt="" />
        </div>
        <ul class="form-content-description">
          <li class="one-third">
            <h4>编号</h4>
            <span>{{ lectureDetail.id }}</span>
          </li>
          <li class="one-third">
            <h4>
              学习数
              <span>{{
                lectureDetail.learn_nums != null
                  ? lectureDetail.learn_nums
                  : "暂无"
              }}</span>
            </h4>
          </li>
          <li class="one-third">
            <h4>
              评分
              <span>{{
                lectureDetail.score ? lectureDetail.score : "暂无"
              }}</span>
            </h4>
          </li>
          <li class="exclusive">
            <h4>中文标题</h4>
            <span>{{
              lectureDetail.chinese_title ? lectureDetail.chinese_title : "暂无"
            }}</span>
          </li>
          <li class="exclusive">
            <h4>英文标题</h4>
            <span>{{
              lectureDetail.english_title ? lectureDetail.english_title : "暂无"
            }}</span>
          </li>
          <li class="exclusive">
            <h4>课程系列</h4>
            <span v-for="(item, index) in lectureDetail.series" :key="index"
              >{{ index != 0 ? "," : "" }}{{ item.chinese_name }}</span
            >
          </li>
          <li class="exclusive">
            <h4>学科编码</h4>
            <span v-if="lectureDetail.classification">{{
              lectureDetail.classification.english_name
            }}</span>
            <span v-else>暂无</span>
          </li>
          <li class="half">
            <h4>授课老师</h4>
            <span v-if="lectureDetail.scholar">{{
              lectureDetail.scholar.chinese_name
            }}</span>
            <span v-else>暂无</span>
          </li>
          <li class="half">
            <h4>所属院校</h4>
            <span v-if="lectureDetail.university">{{
              lectureDetail.university.chinese_name
            }}</span>
            <span v-else>暂无</span>
          </li>
          <li class="half">
            <h4>课程时长</h4>
            <span v-if="lectureDetail.duration">{{
              lectureDetail.duration
            }}</span>
            <span v-else>暂无</span>
          </li>
          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="lectureDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>

    <div class="detail-form-information" v-show="isEditting">
      <h2>基本信息</h2>
      <div class="information-hint">
        <span>
          创建于:
          {{ $dtime(lectureDetail.createTime).format("YYYY-MM-DD") }} &nbsp;
        </span>
        <span>
          最近更新:
          {{ $dtime(lectureDetail.updateTime).format("YYYY-MM-DD") }}</span
        >
      </div>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="form-content-img">
          <UploadImage
            :img="lectureDetail.cover_image"
            :width="268"
            :height="150"
            @getUploadImage="getUploadImageCover"
            class="form-content-img"
          ></UploadImage>
        </div>

        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="one-third">
            <h4>编号<span>*</span></h4>
            <span>{{ lectureDetail.id }}</span>
          </li>
          <li class="one-third">
            <h4>学习数</h4>
            <el-input-number
              v-model.number="lectureDetail.learn_nums"
              placeholder=""
            ></el-input-number>
          </li>
          <li class="one-third">
            <h4>评分</h4>
            <el-input-number
              v-model.number="lectureDetail.score"
              placeholder=""
            ></el-input-number>
          </li>
          <li class="exclusive">
            <h4>中文标题<span>*</span></h4>
            <el-input
              v-model="lectureDetail.chinese_title"
              placeholder="必填项"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>英文标题<span>*</span></h4>
            <el-input
              v-model="lectureDetail.english_title"
              placeholder="必填项"
            ></el-input>
          </li>
          <li class="half">
            <h4>课程系列</h4>
            <el-select
              v-model="lectureDetail.series"
              multiple
              placeholder="请选择"
              value-key="chinese_name"
            >
              <el-option
                v-for="item in seriesList"
                :key="item.label"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>

          <li class="half">
            <h4>学科编码</h4>
            <el-select v-model="lectureDetail.classification.id" clearable>
              <el-option
                v-for="(item, index) in classList"
                :key="index"
                :label="item.english_name"
                :value="parseInt(item.id)"
              ></el-option>
            </el-select>
          </li>
          <li class="half">
            <h4>授课老师</h4>

            <el-autocomplete
              v-if="lectureDetail.scholar"
              v-model="lectureDetail.scholar.chinese_name"
              value-key="chinese_name"
              :fetch-suggestions="searchScholar"
              @select="handleScholarSelect"
              placeholder="选择学者"
            >
            </el-autocomplete>
          </li>
          <li class="half">
            <h4>所属院校</h4>

            <el-autocomplete
              v-if="lectureDetail.university"
              v-model="lectureDetail.university.chinese_name"
              value-key="chinese_name"
              :fetch-suggestions="searchUniversity"
              @select="handleUniversitySelect"
              placeholder="选择学者"
            >
            </el-autocomplete>
          </li>
          <li class="half">
            <h4>课程时长</h4>
            <el-input
              v-model="lectureDetail.duration"
              placeholder="必填项"
            ></el-input>
          </li>
          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="lectureDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>

    <!-- 课程标签 -->

    <div class="pc-dataDetail-tags">
      <h2>课程标签</h2>
      <div class="input" v-if="isEditting">
        <keywordsinput
          :maxLen="18"
          v-model="lectureDetail.tags"
        ></keywordsinput>
      </div>
      <div v-else class="show">
        <p v-for="(tag, index) in lectureDetail.tags" :key="index">
          {{ tag }}
        </p>
      </div>
    </div>

    <!-- 课程简介 -->
    <div class="pc-dataDetail-intro">
      <h2>院校标签</h2>
      <div class="content">
        <h4>中文简介</h4>
        <el-input
          type="textarea"
          v-if="isEditting"
          :rows="5"
          placeholder="请输入内容"
          v-model="lectureDetail.chinese_introduce"
        >
        </el-input>
        <p v-else>{{ lectureDetail.chinese_introduce }}</p>
      </div>
      <TranslateText
        class="translate-btn"
        v-if="isEditting"
        :chinese="lectureDetail.chinese_introduce"
        :english="lectureDetail.english_introduce"
        @returnTranslate="returnTranslate"
      />
      <div class="content">
        <h4>英文简介</h4>
        <el-input
          type="textarea"
          :rows="5"
          v-if="isEditting"
          placeholder="请输入内容"
          v-model="lectureDetail.english_introduce"
        >
        </el-input>
        <p v-else>{{ lectureDetail.english_introduce }}</p>
      </div>
    </div>

    <!-- 课程书籍 -->
    <div class="pc-lecture-books" v-show="!isEditting">
      <!-- 课程教材 -->

      <div class="pc-lecture-textbook">
        <h2>课程教材</h2>
        <a class="el-icon-document" :href="lectureDetail.recommend_book">{{
          lectureDetail.recommend_book ? lectureDetail.recommend_book : "暂无"
        }}</a>
      </div>
      <!-- 课程讲义 -->
      <div class="pc-lecture-handouts">
        <h2>课程讲义</h2>
        <a class="el-icon-document" :href="lectureDetail.handout_file">{{
          lectureDetail.handout_file ? lectureDetail.handout_file : "暂无"
        }}</a>
      </div>
    </div>

    <div class="pc-lecture-books" v-show="isEditting">
      <!-- 课程教材 -->
      <div class="pc-lecture-textbook">
        <h2>课程教材</h2>
        <UploadFile
          :file="lectureDetail.recommend_book"
          @getUploadFile="getUploadRecommendBook"
          :title="'教材'"
        ></UploadFile>
      </div>
      <!-- 课程讲义 -->
      <div class="pc-lecture-handouts">
        <h2>课程讲义</h2>
        <UploadFile
          :file="lectureDetail.handout_file"
          @getUploadFile="getUploadHandoutFile"
          :title="'讲义'"
        ></UploadFile>
      </div>
    </div>

    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />

    <!-- 课程视频 -->

    <LectureVideo v-if="$route.query.method == 'update'" />
  </div>
</template>
<script>
import BreadCrumb from "../../componentSet/BreadCrumb";
import UploadImage from "../../componentSet/uploadImage.vue";
import LectureVideo from "./components/LectureVideo.vue";
import UploadFile from "../../componentSet/uploadFile.vue";
import SaveGroup from "../../componentSet/SaveGroup.vue";

import {
  getLecture_Api,
  updateLecture_Api,
  lectureSeriesDropDown_Api,
  lectureClassificationDropDown_Api,
  lectureUniversityDropDown_Api,
  lectureScholarDropDown_Api,
  addLecture_Api,
} from "../../../apis/lecture.api";
import TranslateText from "../../componentSet/TranslateText.vue";
export default {
  components: {
    LectureVideo,
    SaveGroup,
    UploadFile,
    BreadCrumb,
    UploadImage,
    TranslateText,
  },
  data() {
    return {
      lectureDetail: {
        university_name: "",
        university_id: null,
        series: [],
        classification: { id: "" },
        scholar: { id: "" },
        scholar_id: null,
        classification_id: null,
      },
      isEditting: false,
      seriesList: [],
      scholarList: [],
      universityList: [],
      classList: [],
      videoList: [],
      deleteDialogVisible: false,
    };
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "课程列表", link: "/admin/lecture" },
        {
          name: "课程管理",
          link:
            this.$route.query.method == "update"
              ? this.$route.path +
                "?id=" +
                this.$route.query.id +
                "&method=update"
              : this.$route.path + "?method=add",
        },
      ];
    },
  },

  async mounted() {
    if (this.$route.query.method == "update") {
      this.lectureDetail.id = this.$route.query.id;
      this.getLectureDetail();
    } else {
      this.isEditting = true;
    }
    lectureSeriesDropDown_Api().then((res) => {
      this.seriesList = res.data;
    });
    lectureClassificationDropDown_Api().then((res) => {
      this.classList = res.data;
    });
  },
  methods: {
    returnTranslate(data, flag) {
      flag == 1
        ? (this.lectureDetail.english_introduce = data)
        : (this.lectureDetail.chinese_introduce = data);
      console.log(data);
      console.log(flag);
    },
    cancelUpdate() {
      this.getLectureDetail("取消成功");
      this.isEditting = false;
    },
    save() {
      console.log(this.lectureDetail);
      let formattedData = this.validateForm(this.lectureDetail);
      console.log(this.lectureDetail, formattedData);
      if (!formattedData) {
        return;
      } else {
        updateLecture_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getLectureDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    recover() {
      this.getLectureDetail("恢复成功");
    },
    view() {
      window.open(
        "http://wupen.org/lectures/" + this.$route.query.id,
        "_blank"
      );
    },
    cancelAdd() {
      window.close();
    },
    add() {
      console.log(this.lectureDetail);
      let formattedData = this.validateForm(this.lectureDetail);
      if (!formattedData) {
        return;
      } else {
        addLecture_Api(formattedData)
          .then((res) => {
            this.lectureDetail = res.data;
            this.isEditting = false;
            this.getLectureDetail();
            this.$router.push({
              path: "/admin/lecturedetail",
              query: { id: res.data.id, method: "update" },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    validateForm(formData) {
      //表单校验
      console.log(formData);
      if (!formData.chinese_title || !formData.english_title) {
        this.$global.error(this, "请输入中英文标题");
        return false;
      }

      if (formData.scholar && formData.scholar.chinese_name) {
        formData.scholar_id = formData.scholar.id;
      } else {
        formData.scholar_id = null;
      }
      if (formData.university && formData.university.chinese_name) {
        formData.university_id = formData.university.id;
      } else {
        formData.university_id = null;
      }
      if (formData.classification && formData.classification.id) {
        formData.classification_id = formData.classification.id;
      } else {
        formData.classification_id = null;
      }

      if (formData.series) {
        formData.series_id = formData.series.map((item) => {
          return item.id;
        });
      }
      formData.keywords = formData.tags;
      formData.lecture_id = formData.id;
      return formData;
    },
    getUploadHandoutFile(file_url) {
      this.lectureDetail.handout_file = file_url;
    },
    getUploadRecommendBook(file_url) {
      this.lectureDetail.recommend_book = file_url;
    },
    searchScholar(queryString, callback) {
      lectureScholarDropDown_Api(queryString ? queryString : "").then((res) => {
        for (let i of res.data) {
          i.value = i.chinese_name;
        }
        this.scholarList = res.data;
        callback(this.scholarList);
      });
    },
    handleScholarSelect(item) {
      this.lectureDetail.scholar = item;
      this.lectureDetail.scholar_id = item.id;
    },
    searchUniversity(queryString, callback) {
      lectureUniversityDropDown_Api(queryString ? queryString : "").then(
        (res) => {
          for (let i of res.data) {
            i.value = i.chinese_name;
          }
          this.universityList = res.data;
          callback(this.universityList);
        }
      );
    },
    handleUniversitySelect(item) {
      this.lectureDetail.university = item;
      this.lectureDetail.university_id = item.id;
      console.log(this.lectureDetail.university_id);
    },
    getLectureDetail(hint) {
      getLecture_Api(this.lectureDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";

        this.lectureDetail = res.data;
        if (!this.lectureDetail.classification) {
          this.lectureDetail.classification = {};
        }
        if (!this.lectureDetail.scholar) {
          this.lectureDetail.scholar = { chinese_name: "" };
        }
        if (!this.lectureDetail.university) {
          this.lectureDetail.university = { chinese_name: "" };
        }
        console.log(this.lectureDetail);
      });
    },

    getUploadImageCover(data) {
      this.lectureDetail.cover_image = data;
    },

    edit() {
      this.isEditting = true;
    },
  },
};
</script>


<style lang="scss" scoped>
.pc-lecture-detail {
  /deep/ .el-select {
    width: 100%;
  }

  .pc-lecture-textbook,
  .pc-lecture-handouts {
    @include box-model;
    padding-bottom: 50px;
    a {
      word-break: break-all;
      font-size: 14px;
    }
    a:hover {
      color: $lightenYellow;
    }
    a:before {
      color: $mainTitle;
      text-decoration: none;
    }
  }

  //课程教材和讲义
  .pc-lecture-books {
    display: flex;
    width: 100%;
    justify-content: space-between;
    /deep/ button.el-button.el-button--primary.el-button--small {
      padding: 0;
      background: #fff;
      color: #000;
      border: none;
    }
    /deep/ .el-icon-document:before {
      margin-right: 10px;
    }
    .pc-lecture-textbook {
      width: 48%;
      margin-right: 40px;
    }
    .pc-lecture-handouts {
      width: 48%;
    }
  }
}

.form-content-img {
  width: 250px;
  height: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/lecture/LectureDetail.vue